import { useMemo } from 'react'

import {
  useShareViewNavigationNodeLink,
  useShareViewsNavigation,
} from 'modules/shares/utils/shareViewsNavigation'

export function useBackButton() {
  const { previousView } = useShareViewsNavigation()
  const backLink = useShareViewNavigationNodeLink(previousView)

  return useMemo(() => {
    if (!previousView) {
      return {
        content: 'Back to Document',
        link: backLink,
      }
    }

    if (previousView.view === 'canvas') {
      return {
        content: 'Back to Canvas',
        link: backLink,
      }
    }

    if (previousView.view === 'page') {
      return {
        content: 'Back to Artboards',
        link: backLink,
      }
    }

    // If previousView === 'document' or if the state is empty (direct URL hit)
    // use this default back button.
    return {
      content: 'Back to Document',
      link: backLink,
    }
  }, [backLink, previousView])
}
